export default __webpack_public_path__ + "static/media/Ii.d2fa442c.wav";